import { AskTheOracle } from "./AskTheOracle";
import Oracles from "./oracles";
import { OracleTheme } from "./OracleTheme";
import { PayThePrice } from "./PayThePrice";

const oracles = new Oracles(undefined);

export const OracleScreen = () => {
  // Group themes by source
  const sourceToThemes = oracles.tables.reduce((acc, table) => {
    if (!acc[table.source]) {
      acc[table.source] = new Set();
    }
    acc[table.source].add(table.theme);
    return acc;
  }, {} as Record<string, Set<string>>);

  // Convert to array format: [{ source, themes: string[] }]
  const themesBySource = Object.entries(sourceToThemes).map(([source, themeSet]) => ({
    source,
    themes: Array.from(themeSet)
  }));

  return (
    <div>
      <AskTheOracle />
      <PayThePrice />
      {themesBySource.map(({ source, themes }) => (
        <div key={source}>
          <h3>{source}</h3>
          {themes.map((theme) => (
            <OracleTheme key={theme} theme={theme} oracles={oracles} />
          ))}
        </div>
      ))}
    </div>
  );
};
